export const getEditModalId = (itemId: string) => `edit-ruleset-modal-${itemId}`
